import { useLocation, useNavigate, useParams } from "react-router-dom";
import packageService from "../../../../../service/reactQueryServices/services/packageService";
import { useMutation } from "react-query";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { publicWHMCSUrlPice } from "../../../../../components/helper";
import { useDispatch, useSelector } from "react-redux";
import { getPackageServiceIdAction } from "../../../../../service/actions/packageAction";

const RegisterPackage = ({ userId, setResult }: { userId: string, setResult: Function }) => {
    const packageServiceId = useSelector((state: any) => state.packageReducer.getPackageServiceIDResult)
    const { mutateAsync: getPackages } = useMutation("getPackages", packageService.getUpgradablePackagesService);

    const { mutateAsync: activePackage } = useMutation("upgradablePackagesService", packageService.upgradablePackagesService);

    const { i18n } = useTranslation()
    const location = useLocation()
    const params = useParams()
    const dispatch = useDispatch()

    useEffect(() => {
        setResult({ packageLoading: true })

        dispatch(getPackageServiceIdAction({ userId }))
    }, [])
    useEffect(() => {
        if (packageServiceId) {
            handleGetPackages()

        }
    }, [packageServiceId])


    const handleGetPackages = async () => {
        try {

            const response = await getPackages({
                userId: userId, currency: i18n.language === "fa" ? "IRR" : "",

            })

            if (response.status === 200) {
                handleRegisterPackage(response.data.data)

            }
        } catch (error) {
            console.log(error)
        }



    }


    const handleRegisterPackage = async (packageList: any) => {


        try {

            const selectedPackage = packageList.find((item: any) => item.id === params?.packageId)
            const duration = selectedPackage?.durations?.find((item: any) => item.id === params?.durationId)
            if (selectedPackage && duration) {
                const toActiveParams = {
                    url: publicWHMCSUrlPice({
                        action: "UpgradeProduct",
                        serviceid: packageServiceId,
                        type: "product",
                        newproductid: selectedPackage.productIdInWHMCS,
                        paymentmethod: "mellat",
                        // attachments: encodeList,
                        newproductbillingcycle: duration.title === "Month" ? "monthly" : "annually"
                    }),

                    method: "post",
                    acceptBodyType: "",
                    body: "string",
                    userAgent: "string",
                    headers: {
                        "additionalProp1": "string"

                    },
                    responseType: "json"
                }
                const response = await activePackage({ ...toActiveParams })
                if (response.status === 200) {

                    setResult({
                        isFinish: true,
                        upgradeResult: JSON.parse(response.data),
                        packageType: selectedPackage,
                        duration: duration.title,
                        packageLoading: false
                    })
                }
            }

        } catch (error) {
            console.log(error)
        }
    }



    return null
}

export default RegisterPackage